<div class="column">
  @if (isPositive === true && !isTheSame) {
    <i class="arrow up" [ngClass]="{ inverted: swapColors, big: isBigIcon }"></i>
  }
  @if (isPositive === false && !isTheSame) {
    <i class="arrow down" [ngClass]="{ inverted: swapColors, big: isBigIcon }"></i>
  }

  @if (isTheSame) {
    <i class="no-change-arrow" [ngClass]="{big: isBigIcon}"></i>
  }

  @if ((isPositive === undefined || isPositive === null) && !isTheSame) {
    <hr class="neutral" />
  }
</div>
